import { render, staticRenderFns } from "./sales-order-conversion.vue?vue&type=template&id=5b967348&scoped=true&"
import script from "./js/sales-order-conversion.js?vue&type=script&lang=js&"
export * from "./js/sales-order-conversion.js?vue&type=script&lang=js&"
import style0 from "./sales-order-conversion.vue?vue&type=style&index=0&id=5b967348&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b967348",
  null
  
)

export default component.exports